<ng-container *ngIf="vm$ | async as timers">
  <div class="active-timers" *ngIf="timers.length" [class.collapsed]="collapsed">
    <div class="at-header" (click)="toggleCollapsed()">
      <mat-icon class="at-header-icon">timer</mat-icon>
      <span class="at-title">Time tracking</span>
      <span class="at-count">{{ timers.length }}</span>
      <span class="at-header-time" *ngIf="collapsed && timers.length === 1"
            [class.billable]="timers[0].billable">{{ timers[0].elapsedLabel }}</span>
      <mat-icon class="at-chevron">{{ collapsed ? 'expand_less' : 'expand_more' }}</mat-icon>
    </div>

    <div class="at-list" *ngIf="!collapsed">
      <div class="at-item" *ngFor="let t of timers; trackBy: trackByKey">
        <mat-icon class="at-kind-icon" [matTooltip]="t.kind || 'note'">{{ iconFor(t.kind) }}</mat-icon>

        <div class="at-info" [class.clickable]="t.returnUrl" (click)="goTo(t)" [bcNavLink]="timerLink(t)"
             [matTooltip]="t.returnUrl ? 'Open ' + (t.label || 'source') : ''">
          <div class="at-label">{{ t.label || 'Untitled' }}</div>
          <div class="at-sub" *ngIf="t.reference">{{ t.reference }}</div>
        </div>

        <span class="at-time" [class.billable]="t.billable">{{ t.elapsedLabel }}</span>

        <div class="at-actions">
          <button type="button" class="at-btn at-open" *ngIf="t.returnUrl"
                  matTooltip="Open in new tab" [attr.aria-label]="'Open ' + (t.label || 'timer source') + ' in a new tab'" (click)="openInNewTab(t)">
            <mat-icon>open_in_new</mat-icon>
          </button>
          <button type="button" class="at-btn at-stop" matTooltip="Stop &amp; save" [attr.aria-label]="'Stop and save timer for ' + (t.label || 'Untitled')" (click)="stop(t)">
            <mat-icon>stop_circle</mat-icon>
          </button>
          <button type="button" class="at-btn at-discard" matTooltip="Discard (don't save)" [attr.aria-label]="'Discard timer for ' + (t.label || 'Untitled')" (click)="discard(t)">
            <mat-icon>delete_outline</mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-container>
